type Node = {
  type?: string
  text?: string
  children?: Node[]
}

const nodeText = (node: Node): string => {
  if (typeof node.text === "string") return node.text
  if (!node.children) return ""
  return node.children.map(nodeText).join("")
}

export const lexicalToText = (value: unknown): string => {
  if (!value || typeof value !== "object") return ""
  const root = (value as { root?: Node }).root
  if (!root?.children) return ""
  return root.children.map(nodeText).filter(Boolean).join("\n\n")
}
